import React, { useEffect, useState } from "react";
import { func, object, string } from "prop-types";
import TextArea from "antd/lib/input/TextArea";
import styles from "./AddNewCampaign.module.css";
import ImageUpload from "../../shared/ImageUpload";
import {
  getThumbnailForImage,
  getThumbnailFromVideo,
} from "../../../utils/cloudflareTransformUrl";
import { isVideoFileName } from "../../../utils/video";

export default function PhotoExamplesUpload({
  productName,
  onUpload,
  defaultImageUrls,
}) {
  const [imageList, setImageList] = useState([
    {
      sourceMediaUrl: "",
      label: "",
      loading: false,
    },
    {
      sourceMediaUrl: "",
      label: "",
      loading: false,
    },
    {
      sourceMediaUrl: "",
      label: "",
      loading: false,
    },
  ]);

  useEffect(() => {
    if (defaultImageUrls) {
      const newImageList = [...imageList];
      newImageList.forEach((image, index) => {
        image.sourceMediaUrl = defaultImageUrls.fullMediaUrls[index];
        image.label = defaultImageUrls.labels
          ? defaultImageUrls.labels[index]
          : "";
      });
      setImageList(newImageList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultImageUrls]);

  const _onUpload = newImageList => {
    onUpload({
      fullMediaUrls: newImageList.map(image => image.sourceMediaUrl),
      labels: newImageList.map(image => image.label),
    });
  };

  const onUploadImage = async (urls, index) => {
    const newImageList = [...imageList];
    newImageList[index].sourceMediaUrl = urls.sourceMediaUrl;

    if (onUpload) {
      _onUpload(newImageList);
    }
  };

  const getThumbnail = image => {
    if (!image.sourceMediaUrl) {
      return null;
    }
    return isVideoFileName(image.sourceMediaUrl)
      ? getThumbnailFromVideo(image.sourceMediaUrl)
      : getThumbnailForImage(image.sourceMediaUrl);
  };

  return (
    <div className={styles.photoExamplesContainer}>
      {imageList.map((image, index) => {
        return (
          <div key={index} style={{ textAlign: "center", marginRight: "8px" }}>
            <ImageUpload
              imageSizeValidation={(width, height) =>
                width >= 250 && width <= 1200 && width === height
              }
              altText={`Product Example ${index + 1}`}
              errorMessage="Image dimensions must be at least 250x250 pixels and at most 1200x1200 pixels and must be a square (equal width and height)"
              imageName={`${productName}_example_${index + 1}`}
              onUpload={urls => onUploadImage(urls, index)}
              containerName="product-images"
              defaultImageUrl={getThumbnail(image)}
              mimeTypes={[
                "image/jpeg",
                "image/png",
                "image/webp",
                "image/gif",
                "video/mp4",
              ]}
            />
            <div>Label for Example {index + 1}:</div>
            <TextArea
              rows={4}
              value={imageList[index].label}
              style={{ width: "200px" }}
              onChange={e => {
                const newImageList = [...imageList];
                newImageList[index].label = e.target.value;
                setImageList(newImageList);
                if (onUpload) {
                  _onUpload(newImageList);
                }
              }}
            />
          </div>
        );
      })}
    </div>
  );
}

PhotoExamplesUpload.propTypes = {
  productName: string,
  onUpload: func,
  defaultImageUrls: object,
};
